export const HEARTBEAT_INTERVAL_MS = 30_000;
export const SESSION_PAGES = ['calibration', 'record'];

let endpointUnavailable = false;

/** Test-only reset for module-level 404 gate. */
export function resetPiPresenceEndpointState() {
  endpointUnavailable = false;
}

export function isPiPresenceEndpointUnavailable() {
  return endpointUnavailable;
}

/**
 * Fire-and-forget UI presence heartbeat to the Pi recording app.
 * Never throws; disables further sends after a 404 response.
 */
export function sendUiPresence(page) {
  if (endpointUnavailable) {
    return Promise.resolve();
  }

  const baseUrl = typeof window !== 'undefined' ? window.RECORDING_URL : '';
  if (!baseUrl) {
    return Promise.resolve();
  }

  const token = localStorage.getItem('token');
  const headers = {
    'Content-Type': 'application/json',
  };
  if (token) {
    headers.Authorization = 'Bearer ' + token;
  }

  return fetch(baseUrl + '/api/ui-presence', {
    method: 'POST',
    headers,
    body: JSON.stringify({ page }),
  })
    .then((res) => {
      if (res.status === 404) {
        endpointUnavailable = true;
      }
    })
    .catch(() => {});
}
